module.exports = __webpack_public_path__ + "img/flag_rect_239.99245c77.png";